import {
  type HotelPanelState,
  type HotelPlannerBlock,
  type HotelPlannerRefineContext,
  policyLimitsFromOffers,
  toHotelRefineOffer,
} from '@voll-intelligence/genui-contract';
import type { HotelSearchPreviewState } from './use_hotel_search_preview.js';

/** O contexto da TELA que um toque leva ao agente (M1 · 1.1a): o mesmo objeto
 *  que `useHotelSearchContextSync` despacha para o refino por texto, montado
 *  na hora do toque. Só existe quando a busca client-side RODOU neste card
 *  (`phase === 'ready'` + `selection`): fora disso a cena veio do agente e ele
 *  já a tem. Ofertas na forma ENXUTA e capadas em 30 (teto do schema; o web-chat
 *  ainda corta no orçamento do WAF).
 *
 *  A cena tem de ser DESTE card (mesma guarda de `useHotelSearchContextSync`):
 *  o preview sobrevive a uma troca de bloco, e o contexto de um challenge antigo
 *  hidrataria o FSM com a busca de outro card. */
export function tapRefineContext(
  ui: HotelPlannerBlock,
  previewState: HotelSearchPreviewState,
  /** M1 · 1.1b — o estado do painel e o total da busca, quando o chamador os
   *  tem (organismo/card). Ausente: o contexto sai como na Onda 1. */
  screen?: { panel?: HotelPanelState; total?: number },
): HotelPlannerRefineContext | undefined {
  if (previewState.challengeId !== ui.challengeId) return undefined;
  if (previewState.phase !== 'ready' || !previewState.selection) return undefined;
  const sessionId = previewState.data?.sessionId ?? ui.sessionId;
  const offers = previewState.data?.offers ?? [];
  // Uma vez por contexto, não por oferta (ver `policyLimitsFromOffers`).
  const policyLimits = policyLimitsFromOffers(offers);
  return {
    kind: 'hotel_planner_refine',
    blockId: ui.id,
    selection: previewState.selection,
    ...(sessionId ? { sessionId } : {}),
    ...(offers.length > 0 ? { offers: offers.slice(0, 30).map(toHotelRefineOffer) } : {}),
    ...(policyLimits ? { policyLimits } : {}),
    ...(screen?.panel ? { panel: screen.panel } : {}),
    ...(screen?.total === undefined ? {} : { total: screen.total }),
  };
}
